import { type IXSLXImport } from '@principle-theorem/shared';
import type { Row } from 'exceljs';
import {
  ITransactionTypeXSLX,
  TRANSACTION_TYPE_HEADERS,
} from './transaction-type-to-xlsx';

export class XSLXToTransactionType
  implements IXSLXImport<ITransactionTypeXSLX>
{
  headers = TRANSACTION_TYPE_HEADERS;

  translate(row: Row): ITransactionTypeXSLX {
    return {
      sourceId: row.getCell('sourceId').value?.toString() ?? '',
      sourceName: row.getCell('sourceName').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as ITransactionTypeXSLX['mapTo'],
    };
  }
}
